import { endpoint } from 'services/endpoint';
import { httpPay } from 'services/http';
import { TPaymentsApi } from './types';

export const payments: TPaymentsApi = {
	getPayable: () => httpPay.get(endpoint.payments.PAYABLE).then((response) => response.data),
	getQuote: (payload) =>
		httpPay.post(endpoint.payments.QUOTE, payload).then((response) => response.data),
	tryToPay: (payload) =>
		httpPay.post(endpoint.payments.TRY_TO_PAY, payload).then((response) => response.data),
	getStatus: (transactionId) =>
		httpPay.get(endpoint.payments.STATUS(transactionId)).then((response) => response.data),
	getInvoiceReceipts: (invoiceIds) =>
		httpPay.get(endpoint.payments.INVOICE_RECEIPTS(invoiceIds)).then((response) => response.data),
};
